export default __webpack_public_path__ + "static/media/google_logo.221f782d.png";